(function () {
  var CONFIG = {
    cardSelector: '[data-product-card]',
    storageKey: 'sw_preferred_size',
    dismissKey: 'sw_size_dismissed'
  };

  // [UK label, EU, US, foot length range (cm), max foot length (cm)]
  // The UK label must match your Shopify "Size" option values (5,6,7...).
  var CHART = [
    // ['5',  '39', '6',  '23.9 - 24.6', 24.6],
    ['6',  '40', '7',  '24.7 - 25.5', 25.5],
    ['7',  '41', '8',  '25.6 - 26.3', 26.3],
    ['8',  '42', '9',  '26.4 - 27.2', 27.2],
    ['9',  '43', '10', '27.3 - 28.0', 28.0],
    ['10', '44', '11', '28.1 - 28.9', 28.9],
    ['11', '45', '12', '29.0 - 29.7', 29.7],
    // ['12', '46', '—',  '29.8 - 30.6', 30.6]
  ];

  function run() {
    var $ = function (id) { return document.getElementById(id); };
    var overlay = $('sp-overlay');
    if (!overlay) return;
    var sizesEl = $('sp-sizes'), chosenEl = $('sp-chosen'), selectBtn = $('sp-select'),
        selected = null, fit = 'regular', recommended = null;
        var barEl = $('sp-bar'), emptyEl = $('sp-empty'), barSizeEl = $('sp-bar-size');

    function store(k, v) { try { v === null ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch (e) {} }
    function load(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

    function renderSizes() {
      sizesEl.innerHTML = '';
      CHART.forEach(function (row) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sp-size' + (row[0] === selected ? ' active' : '');
        b.textContent = row[0];
        b.addEventListener('click', function () { pick(row[0]); });
        sizesEl.appendChild(b);
      });
    }
    function pick(label) {
      selected = label; chosenEl.textContent = label; selectBtn.disabled = false; renderSizes();
    }

    /* size chart */
    $('sp-chart').innerHTML =
      '<tr><th>UK</th><th>EU</th><th>US</th><th>Foot (cm)</th></tr>' +
      CHART.map(function (r) {
        return '<tr><td>' + r[0] + '</td><td>' + r[1] + '</td><td>' + r[2] + '</td><td>' + r[3] + '</td></tr>';
      }).join('');
    $('sp-chart-link').addEventListener('click', function (e) {
      e.preventDefault(); var box = $('sp-chartbox'); box.hidden = !box.hidden;
    });

    /* size finder */
    $('sp-help-btn').addEventListener('click', function () { $('sp-help').classList.toggle('open'); });
    $('sp-fit').addEventListener('click', function (e) {
      var b = e.target.closest('button[data-fit]'); if (!b) return;
      fit = b.dataset.fit;
      [].forEach.call($('sp-fit').children, function (x) { x.classList.toggle('active', x === b); });
    });
    $('sp-calc').addEventListener('click', function () {
      var foot = parseFloat($('sp-foot').value);
      if (!foot) { alert('Please enter your foot length in cm'); return; }
      var ease = { snug: 0, regular: 0.3, roomy: 0.8 }[fit];
      var idx = CHART.length - 1;
      for (var i = 0; i < CHART.length; i++) {
        if (CHART[i][4] >= foot + ease) { idx = i; break; }
      }
      recommended = CHART[idx][0];
      $('sp-rec').textContent = 'UK ' + recommended + ' / EU ' + CHART[idx][1];
      $('sp-result').hidden = false;
    });
    $('sp-apply').addEventListener('click', function () { if (recommended) pick(recommended); });

    /* open / close */
    function openPopup() {
      selected = load(CONFIG.storageKey);
      chosenEl.textContent = selected || '—';
      selectBtn.disabled = !selected;
      renderSizes();
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closePopup() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      try { sessionStorage.setItem(CONFIG.dismissKey, '1'); } catch (e) {}
    }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    document.querySelector('[data-sp-close]').addEventListener('click', closePopup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closePopup();
    });

    selectBtn.addEventListener('click', function () {
      store(CONFIG.storageKey, selected); closePopup(); applyFilter();
    });
    $('sp-change').addEventListener('click', openPopup);
    $('sp-clear').addEventListener('click', function () { store(CONFIG.storageKey, null); applyFilter(); });

    /* "UK 6", "6", "UK6 / EU 39" -> "6" */
    function norm(s) {
      var m = String(s || '').match(/\d+(\.\d+)?/);
      return m ? m[0] : '';
    }

    /* put bar + empty message above the grid container (outside AJAX-replaced area) */
  function placeBar() {
  var grid = document.getElementById('ProductGridContainer');
  if (!grid) return;
  if (grid.firstElementChild !== barEl) {
    grid.insertBefore(emptyEl, grid.firstChild);
    grid.insertBefore(barEl, grid.firstChild);
  }
}

    /* filtering */
   function applyFilter() {
  var size = load(CONFIG.storageKey), shown = 0;
  var cards = document.querySelectorAll(CONFIG.cardSelector);
  var want = norm(size);
  cards.forEach(function (card) {
    var avail = (card.getAttribute('data-available-sizes') || '').split('|').map(norm);
    var ok = !size || avail.indexOf(want) !== -1;
    card.classList.toggle('sp-hidden-product', !ok);
    if (ok) shown++;
  });
  barEl.classList.toggle('show', !!size);
  var label = size || '';
  if (barSizeEl.textContent !== label) barSizeEl.textContent = label;
  emptyEl.classList.toggle('show', !!size && cards.length > 0 && shown === 0);
}

    /* init */
    placeBar();
    applyFilter();
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(CONFIG.dismissKey) === '1'; } catch (e) {}
    if (!load(CONFIG.storageKey) && !dismissed) openPopup();

    /* re-apply after theme re-renders products (filters, sorting, load more) - debounced */
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { placeBar(); applyFilter(); }, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();